import sy from '~/styles';
import {Link} from '~/components/controls';
import {articles as articlesApi} from '~/api/private';
import {SOURCES} from '~/types/sources';
import PropTypes from 'prop-types';

const VrooamDetailsLink = ({license, dealer_id, article}) => {
  const onLinkPress = async () => {
    const result = await articlesApi.details_link(
      license,
      dealer_id,
      article.number,
    );
    if (!result.success) {
      return;
    }

    window.open(result.link, '_blank');
  };

  const source = SOURCES[article.source] ?? article.source;

  return (
    <Link textStyle={[sy.small, sy['text-lightgray']]} onPress={onLinkPress}>
      {source}&nbsp;&middot;&nbsp;{article.number}
    </Link>
  );
};
VrooamDetailsLink.propTypes = {
  license: PropTypes.any,
  dealer_id: PropTypes.any,
  article: PropTypes.any,
};

export default VrooamDetailsLink;
